// ── Budgets Engine ────────────────────────────────────────────────────────────

import { filterByMonth } from "./transactions";

/**
 * Realisasi tiap kategori vs anggaran untuk satu bulan
 * @returns {Array<{ ...cat, actual, budget, wallet, walletId, over, pct }>}
 */
export function getBudgetRealization(budgets, transactions, categories, wallets, month, year) {
  const monthTxs     = filterByMonth(transactions, month, year).filter(t => t.type === "expense" || t.type === "investasi");
  const monthBudgets = budgets.filter(b => b.month === month && b.year === year);
  const budgetCats   = categories.filter(c => c.type === "expense" || c.type === "investasi");

  return budgetCats.map(cat => {
    const actual = monthTxs.filter(t => t.categoryId === cat.id).reduce((a, t) => a + t.amount, 0);
    const budgetEntry = monthBudgets.find(b => b.categoryId === cat.id);
    const budget = budgetEntry?.amount || 0;
    const wallet = wallets.find(w => w.id === budgetEntry?.walletId);
    const pct    = budget > 0 ? Math.min(actual / budget, 1) : 0;
    return { ...cat, actual, budget, wallet, walletId: budgetEntry?.walletId || "", pct, over: budget > 0 && actual > budget };
  }).filter(c => c.actual > 0 || c.budget > 0);
}

/**
 * Summary anggaran per tipe (expense vs investasi)
 * @returns {{ expBudget, expActual, invBudget, invActual, totalBudget, pieData }}
 */
export function getBudgetSummary(catData) {
  const expData = catData.filter(c => c.type === "expense");
  const invData = catData.filter(c => c.type === "investasi");
  const expBudget = expData.reduce((a, c) => a + c.budget, 0);
  const expActual = expData.reduce((a, c) => a + c.actual, 0);
  const invBudget = invData.reduce((a, c) => a + c.budget, 0);
  const invActual = invData.reduce((a, c) => a + c.actual, 0);
  const totalBudget = expBudget + invBudget;
  const pieData = [
    { name: "Pengeluaran", value: expBudget, color: "#EF4444" },
    { name: "Investasi",   value: invBudget, color: "#E8A21C" },
  ].filter(d => d.value > 0);
  return { expData, invData, expBudget, expActual, invBudget, invActual, totalBudget, pieData };
}

/**
 * Anggaran dikelompokkan per rekening (untuk section Transfer ke Rekening)
 * @returns {Array<{ wallet, totalBudget, totalActual, cats }>}
 */
export function getBudgetByWallet(catData) {
  const map = {};
  catData.forEach(cat => {
    if (!cat.walletId) return;
    if (!map[cat.walletId]) map[cat.walletId] = { wallet: cat.wallet, totalBudget: 0, totalActual: 0, cats: [] };
    map[cat.walletId].totalBudget += cat.budget;
    map[cat.walletId].totalActual += cat.actual;
    map[cat.walletId].cats.push(cat);
  });
  return Object.values(map).filter(g => g.wallet);
}

/**
 * MoM comparison untuk anggaran (pengeluaran & investasi aktual)
 * @returns {{ prevExpActual, prevInvActual }}
 */
export function getBudgetMoM(transactions, month, year) {
  const prevMonth = month === 0 ? 11 : month - 1;
  const prevYear  = month === 0 ? year - 1 : year;
  const prevTxs   = filterByMonth(transactions, prevMonth, prevYear);
  return {
    prevExpActual: prevTxs.filter(t => t.type === "expense").reduce((a, t) => a + t.amount, 0),
    prevInvActual: prevTxs.filter(t => t.type === "investasi").reduce((a, t) => a + t.amount, 0),
  };
}
